import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    AuthorNotify: {},

};

const AuthorNotifySlice = createSlice({
    name: 'authornotify',
    initialState,
    reducers: {
        setToast(state, action) {
            state.AuthorNotify = action.payload;
        },


    },
});



export const AuthorNotifyPostApi = (tokendata, payload) => async (dispatch) => {

    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/publisher/notifyToAuthor`, payload,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            // dispatch(setNotificationList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}




export const { setToast } = AuthorNotifySlice.actions;
const AuthorNotifyReducer = AuthorNotifySlice.reducer;

export default AuthorNotifyReducer;
